import { CartItemNew } from "./CartItemNew";

export default CartItemNew;
